import { render, staticRenderFns } from "./Tablas.vue?vue&type=template&id=3b1cfb8a&"
import script from "./Tablas.vue?vue&type=script&lang=js&"
export * from "./Tablas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports